<eess-bienvenido></eess-bienvenido>
<div class="d-flex jc-c">
    <div class="">
      <div class="row mb-5">
        <div class="col-12 d-flex jc-c">
          <div>
            <ng-lottie [options]="lottieInfo" width="140px" height="140px"></ng-lottie>
          </div>
        </div>
      </div>
        <h2 class="ta-c c-warning">{{config.titulo}}</h2>
        <div class="col-lg-10 d-flex jc-c col-md-9 mx-auto">
          <p class="mt-4 ta-c c-gray">
            {{config.mensaje}}
          </p>
        </div>
      <div class="col-12 col-sm-8 col-md-4 mx-auto bch-button-auto-size">
        <bch-button [button]="buttonVolver" (click)="toggleActive()"></bch-button>
      </div>
    </div>
</div>
